import {useEffect, useRef} from 'react';
import {animate, motion, useInView, useMotionValue, useReducedMotion, useTransform} from 'motion/react';

/** Número que cuenta hasta su valor al entrar en viewport (ej. +10K, +200). */
export function Counter({
  to,
  prefix = '',
  suffix = '',
  className,
}: {
  to: number;
  prefix?: string;
  suffix?: string;
  className?: string;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {once: true, margin: '-40px'});
  const reduced = useReducedMotion();
  const value = useMotionValue(reduced ? to : 0);
  const text = useTransform(value, (v) => `${prefix}${Math.round(v).toLocaleString('es-PR')}${suffix}`);

  useEffect(() => {
    if (inView && !reduced) {
      const controls = animate(value, to, {duration: 1.6, ease: [0.16, 1, 0.3, 1]});
      return controls.stop;
    }
  }, [inView, reduced, to, value]);

  return (
    <span ref={ref} className={className}>
      <motion.span>{text}</motion.span>
    </span>
  );
}
